import moment from "moment-timezone";
import React, { Fragment, PureComponent } from "react";
import { connect } from "react-redux";
import { PropTypes } from "prop-types";
import { Table, Icon, Popup } from "semantic-ui-react";

import LinkWithReset from "../utils/LinkWithReset.jsx";
import ActionDropdownMenu from "../actionDropdownMenu/ActionDropdownMenu.jsx";
import ResourceMarker from "../marking/ResourceMarker.jsx";
import ResourceSunsetMarker from "./ResourceSunsetMarker.jsx";
import { MediaAs } from "../../styles/Media.js";

import {
  ACTION_URI_CHUNKS,
  RESOURCE_URI_CHUNKS
} from "../../constants/entity.js";
import { IMAGE_VENDORS } from "../../constants/images.js";
import { ICON_MAP } from "../../constants/iconMap.js";

import { selectCopy } from "../../state/reducers/locale/copySelector.js";

class ImageRow extends PureComponent {
  static propTypes = {
    entity: PropTypes.object.isRequired,
    onDelete: PropTypes.func.isRequired,
    copyKey: PropTypes.string.isRequired,
    copy: PropTypes.func.isRequired
  };

  static defaultProps = {
    copyKey: "image"
  };

  onDelete = () => {
    const { entity, onDelete } = this.props;
    onDelete(entity["@id"]);
  };

  getDateString(isoDate) {
    if (!isoDate) return "-";
    return moment(isoDate).format("DD-MM-YY");
  }

  getAdditionalMarkers() {
    const { copy, copyKey, entity } = this.props;

    return (
      <Fragment>
        {entity.sunset && <ResourceSunsetMarker data={entity} />}
        {entity.vendor === IMAGE_VENDORS.GOLDEN && (
          <Popup
            trigger={<Icon name="file image" size="large" color="yellow" />}
            position="top right"
            size="tiny"
            offset={[5, 0]}
            hideOnScroll
            content={copy(`${copyKey}.golden_image_label`)}
          />
        )}
      </Fragment>
    );
  }

  getRegionNames(entity) {
    return entity.regions.reduce((acc, region) => {
      if (!region.name) return acc;
      return acc !== "" ? `, ${region.name}` : `${region.name}`;
    }, "");
  }

  getClonePath(atId) {
    return `/${RESOURCE_URI_CHUNKS.IMAGES}/${ACTION_URI_CHUNKS.CLONE}${atId}`;
  }

  getCreatePath(atId) {
    return `/${RESOURCE_URI_CHUNKS.IMAGES}/${ACTION_URI_CHUNKS.CREATE}${atId}`;
  }

  render() {
    const { entity, copyKey, copy } = this.props;

    return (
      <Table.Row key={entity.id} textAlign="center">
        <Table.Cell textAlign="left">
          <LinkWithReset to={entity["@id"]} className="table-link">
            <Icon name={ICON_MAP[entity.operatingSystem]} /> {entity.name}
          </LinkWithReset>
        </Table.Cell>
        <Table.Cell textAlign="right" collapsing>
          {this.getAdditionalMarkers()}
        </Table.Cell>
        <MediaAs
          greaterThanOrEqual="tablet"
          as={Table.Cell}
          textAlign="left"
          collapsing
        >
          {entity.provider.name}
        </MediaAs>
        <Table.Cell textAlign="left" collapsing>
          {this.getRegionNames(entity)}
        </Table.Cell>
        <MediaAs
          greaterThanOrEqual="tablet"
          as={Table.Cell}
          textAlign="left"
          collapsing
        >
          {this.getDateString(entity.createdAt)}
        </MediaAs>
        <Table.Cell collapsing>
          <ActionDropdownMenu
            data={entity}
            viewPath={entity["@id"]}
            createImagePath={this.getCreatePath(entity["@id"])}
            cloneImagePath={this.getClonePath(entity["@id"])}
            onDelete={this.onDelete}
            copy={copy(`basic_resource_actions`)}
          />
        </Table.Cell>
        <Table.Cell verticalAlign="middle" collapsing>
          <ResourceMarker
            marking={entity.marking}
            circular={true}
            style={{ display: "block" }}
          />
        </Table.Cell>
      </Table.Row>
    );
  }
}

const mapStateToProps = state => ({
  copy: selectCopy(state)
});

export default connect(mapStateToProps)(ImageRow);
